import React, { memo } from 'react';
import makeBodyText from '../../utils/makeText';
import { DEFAULTS } from './constants';
import styles from './index.module.scss';
const ReferFriend = memo(({ withReferFriend, contact }) => {
    var _a, _b;
    if (!withReferFriend) {
        return null;
    }
    const _handleClick = () => {
        // @ts-ignore
        if (window.extole) {
            // @ts-ignore
            window.extoleCreateZone({ name: 'global_footer', element_id: 'extole_zone_global_footer' });
        }
    };
    return (React.createElement("div", { className: styles.referFriend },
        React.createElement("div", { className: styles.referLeft },
            React.createElement("span", { className: `${makeBodyText('XL')} ${styles.title}` }, ((_a = contact === null || contact === void 0 ? void 0 : contact.referFriend) === null || _a === void 0 ? void 0 : _a.title) || DEFAULTS.contact.referFriend.title),
            React.createElement("span", { className: `${makeBodyText('L')} ${styles.text}` }, ((_b = contact === null || contact === void 0 ? void 0 : contact.referFriend) === null || _b === void 0 ? void 0 : _b.text) || DEFAULTS.contact.referFriend.text)),
        React.createElement("div", { className: styles.referRight, onClick: _handleClick },
            React.createElement("span", { id: 'extole_zone_global_footer' }))));
});
ReferFriend.displayName = 'ReferFriend';
export default ReferFriend;
